var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.init)?_c('div',{staticClass:"chat-wrapper"},[_c('ChatLightbox'),_c('ChatAdminSelector'),_c('div',{staticClass:"chat-new-main"},[_c('ChatRoomSelector'),(_vm.selectedChatRoom !== false)?_c('ChatWindow'):_c('div',{staticStyle:{"width":"800px","max-width":"100%"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }